import English from '~/content/locales/en.json';
import German from '~/content/locales/de.json';
import GermanCH from '~/content/locales/de-CH.json';
import GermanAT from '~/content/locales/de-AT.json';
import FrenchCH from '~/content/locales/fr-CH.json';

export const buildLocaleMessages = (
    locale: Locale | undefined,
    packageMessages: Record<Locale, Record<string, string> | undefined>
): Record<string, string> => {
    const deMessages = packageMessages['de-DE'] || {};

    switch (locale) {
        case 'de-AT':
            return { ...deMessages, ...packageMessages['de-AT'] };
        case 'de-CH':
            return { ...deMessages, ...packageMessages['de-CH'] };
        case 'de-DE':
            return deMessages;
        case 'en-GB':
            return { ...deMessages, ...packageMessages['en-GB'] };
        case 'fr-CH':
            return { ...deMessages, ...packageMessages['fr-CH'] };
        default:
            return deMessages;
    }
};

export const getLocaleStrings = (locale: Locale) => {
    return buildLocaleMessages(locale, {
        'en-GB': English,
        'de-DE': German,
        'de-CH': GermanCH,
        'de-AT': GermanAT,
        'fr-CH': FrenchCH
    });
};
